"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _ModalTeamForm = _interopRequireDefault(require("./components/ModalTeamForm"));
var _ModalTeamDetail = _interopRequireDefault(require("./components/ModalTeamDetail"));
var _ModalUserTag = _interopRequireDefault(require("./components/ModalUserTag"));
var _InputSearch = _interopRequireDefault(require("@/ui/components/InputSearch"));
var _constants = require("@/config/constants");
var _UserBadge = _interopRequireDefault(require("@/ui/components/UserBadge"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var actions = {
  DISABLED: 'DISABLED',
  PRINT: 'PRINT',
  PRINT_USER_TAG: 'PRINT_USER_TAG',
  EDIT: 'EDIT',
  DELETE: 'DELETE'
};
var _default = exports.default = {
  name: 'Teams',
  components: {
    Page: _Page.default,
    InputSearch: _InputSearch.default,
    UserBadge: _UserBadge.default,
    ModalUserTag: _ModalUserTag.default
  },
  data: function data() {
    return {
      search: '',
      userEdit: {},
      modalTeam: null,
      modalDetail: null,
      currentPage: 1,
      userSelected: undefined,
      optionsTable: _constants.OPTIONS_TABLE,
      whiteList: _constants.LIST_ADMINS,
      position: _constants.POSITION_DROPDOWN,
      actions: actions,
      idElementPrint: 'employees-badge-card-list',
      userTagModal: {
        active: false,
        userId: null
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    menuItemsFarm: 'menuItemsFarm',
    isLoading: 'isLoading',
    currentUser: 'userAdmin',
    users: 'allUsers',
    farm: 'GET_FARM'
  })), {}, {
    listUsers: function listUsers() {
      var _this = this;
      if (!this.users.length) return [];
      var arrayUser = this.users.filter(function (user) {
        var fullName = user.firstName + ' ' + user.lastName;
        return fullName.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
      });
      return arrayUser;
    }
  }),
  mounted: function mounted() {
    this.getUsers();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchUsers', 'updateUser', 'deleteUser', 'saveNewTypeService', 'editTypeService', 'setLoading'])), {}, {
    verifyAccessDeleteDisabled: function verifyAccessDeleteDisabled(row) {
      return !this.whiteList.includes(row.role);
    },
    verifyEdit: function verifyEdit(role) {
      if (this.whiteList.includes(role)) {
        return this.whiteList.includes(this.currentUser.role);
      }
      return true;
    },
    openModal: function openModal() {
      var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.modalTeam = this.$buefy.modal.open({
        parent: this,
        component: _ModalTeamForm.default,
        hasModalCard: true,
        canCancel: ['escape', 'outside'],
        scroll: 'keep',
        props: {
          userEdit: user,
          getUsers: this.getUsers
        }
      });
    },
    openModalDetail: function openModalDetail(row) {
      this.modalDetail = this.$buefy.modal.open({
        parent: this,
        component: _ModalTeamDetail.default,
        hasModalCard: true,
        canCancel: ['escape', 'outside'],
        scroll: 'keep',
        props: {
          user: row,
          print: this.printComponent,
          prepareAction: this.prepareAction,
          actions: this.actions
        }
      });
    },
    prepareAction: function prepareAction(type, row) {
      var self = this;
      switch (type) {
        case actions.DISABLED:
          self.verifyDisabled(row);
          break;
        case actions.PRINT:
          self.userSelected = row;
          self.setLoading(true);
          setTimeout(function () {
            self.setLoading(false);
            self.printComponent(self.idElementPrint);
          }, 2000);
          break;
        case actions.PRINT_USER_TAG:
          self.printUserTag(row);
          break;
        case actions.EDIT:
          self.userEdit = row;
          self.openModal(self.userEdit);
          break;
        case actions.DELETE:
          self.verifyDelete(row);
          break;
      }
    },
    getUsers: function () {
      var _getUsers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.fetchUsers();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getUsers() {
        return _getUsers.apply(this, arguments);
      }
      return getUsers;
    }(),
    printUserTag: function printUserTag(row) {
      if (!(row !== null && row !== void 0 && row.id)) return;
      this.userTagModal = {
        active: true,
        userId: row.id
      };
    },
    closeUserTagModal: function closeUserTagModal() {
      this.userTagModal = {
        active: false,
        userId: null
      };
    },
    verifyDisabled: function verifyDisabled(row) {
      var _this2 = this;
      var type = row.activated ? 'Desabilitar' : 'habilitar';
      this.$buefy.dialog.confirm({
        title: "".concat(type, " usu\xE1rio"),
        message: "Tem certeza de que deseja <b>".concat(type.toLowerCase(), "</b> esse usu\xE1rio?"),
        cancelText: 'Cancelar',
        confirmText: 'Continuar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          return _this2.changeStatusUser(row);
        }
      });
    },
    changeStatusUser: function () {
      var _changeStatusUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var data, response;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              data = {
                activated: !row.activated
              };
              _context2.n = 1;
              return this.updateUser({
                data: data,
                id: row.id
              });
            case 1:
              response = _context2.v;
              if (response) {
                this.getUsers();
                if (this.modalDetail) this.modalDetail.close();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function changeStatusUser(_x) {
        return _changeStatusUser.apply(this, arguments);
      }
      return changeStatusUser;
    }(),
    verifyDelete: function verifyDelete(row) {
      var _this3 = this;
      this.$buefy.dialog.confirm({
        title: 'Excluir usuário',
        message: 'Tem certeza de que deseja <b>excluir</b> esse usuário? <b>Essa ação não pode ser desfeita.</b>',
        cancelText: 'Cancelar',
        confirmText: 'Excluir',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          return _this3.cofirmDeleteUser(row);
        }
      });
    },
    cofirmDeleteUser: function () {
      var _cofirmDeleteUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var response;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.deleteUser(row.id);
            case 1:
              response = _context3.v;
              if (response) this.getUsers();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function cofirmDeleteUser(_x2) {
        return _cofirmDeleteUser.apply(this, arguments);
      }
      return cofirmDeleteUser;
    }(),
    printComponent: function printComponent(idElemente) {
      var newIframe = document.createElement('iframe');
      newIframe.width = '1px';
      newIframe.height = '1px';
      newIframe.src = 'about:blank';

      // for IE wait for the IFrame to load so we can access contentWindow.document.body
      var htmlString = document.getElementById(idElemente).innerHTML;
      var stylesHtml = '';
      for (var _i = 0, _arr = _toConsumableArray(document.querySelectorAll('link[rel="stylesheet"], style')); _i < _arr.length; _i++) {
        var node = _arr[_i];
        stylesHtml += node.outerHTML;
      }
      newIframe.onload = function () {
        var scriptTag = newIframe.contentWindow.document.createElement('script');
        scriptTag.type = 'text/javascript';
        var script = newIframe.contentWindow.document.createTextNode('function Print(){ window.focus(); window.print(); }');
        scriptTag.appendChild(script);
        newIframe.contentWindow.document.write("\n          <!DOCTYPE html>\n          <html>\n            <head>\n              ".concat(stylesHtml, "\n            </head>\n            <body>\n              ").concat(htmlString, "\n            </body>\n          </html>\n        "));
        newIframe.contentWindow.document.body.appendChild(scriptTag);

        // for chrome, a timeout for loading large amounts of content
        setTimeout(function () {
          newIframe.contentWindow.Print();
          newIframe.contentWindow.document.body.removeChild(scriptTag);
          newIframe.parentElement.removeChild(newIframe);
        }, 200);
      };
      document.body.appendChild(newIframe);
    }
  }),
  beforeDestroy: function beforeDestroy() {}
};